import { render } from "./App.vue?vue&type=template&id=1f9bf0d6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1f9bf0d6&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__